import Compute from "../svgs/locationAdmin/compute.svg";
import Networking from "../svgs/locationAdmin/networking.svg";
import Outrun from "../svgs/header/outrun.svg";
import Code from "../svgs/locationAdmin/code.svg";
import Artifactory from "../svgs/locationAdmin/artifactory.svg";
import Storage from "../svgs/locationAdmin/storage.svg";
import AccountSetting from "../svgs/locationAdmin/account.svg";
import Compliance from "../svgs/locationAdmin/compliance.svg";
import Disk from "../svgs/locationAdmin/disk.svg";
import DataBase from "../svgs/locationAdmin/dataBase.svg";
// import icons
import ManageIcon from "../svgs/svgrs/manage.jsx"
import ConsoleIcon from "../svgs/svgrs/console.jsx"
import SubscriptionsIcon from "../svgs/svgrs/subscriptions.jsx"

export const cloudServicesList = [
  {
    subtitle: "cloudServices.compute.title",
    subdescription: "cloudServices.compute.description",
    img: Compute,
    url: "/compute",
  },
  {
    subtitle: "cloudServices.networking.title",
    subdescription: "cloudServices.networking.description",
    img: Networking,
    url: "/networking",
  },
  {
    subtitle: "cloudServices.outrun.title",
    subdescription: "cloudServices.outrun.description",
    img: Outrun,
    url: "/outrun-cloud",
  },
  {
    subtitle: "cloudServices.code.title",
    subdescription: "cloudServices.code.description",
    img: Code,
    url: "/code",
  },
  {
    subtitle: "cloudServices.artifactory.title",
    subdescription: "cloudServices.artifactory.description",
    img: Artifactory,
    url: "/artifactory",
  },
  {
    subtitle: "cloudServices.storage.title",
    subdescription: "cloudServices.storage.description",
    img: Storage,
    url: "/storage",
  },
  {
    subtitle: "cloudServices.accountSetting.title",
    subdescription: "cloudServices.accountSetting.description",
    img: AccountSetting,
    url: "/account-settings",
  },
  {
    subtitle: "cloudServices.compliance.title",
    subdescription: "cloudServices.compliance.description",
    img: Compliance,
    url: "/compliance",
  },
  {
    subtitle: "cloudServices.disk.title",
    subdescription: "cloudServices.disk.description",
    img: Disk,
    url: "/disk",
  },
  {
    subtitle: "cloudServices.dataBase.title",
    subdescription: "cloudServices.dataBase.description",
    img: DataBase,
    url: "/database",
  },
];

export const allToolsList = [
  {
    title: "allTheTools.accountManagement.title",
    description: "allTheTools.accountManagement.description",
    icon: ManageIcon,
    imgUrl: "allTheTools.accountManagement.screenUrl",
    flag: 'accountManagement',
    docsUrl: "allTheTools.accountManagement.docsUrl"
  },
  {
    title: "allTheTools.subscriptions.title",
    description: "allTheTools.subscriptions.description",
    icon: SubscriptionsIcon,
    imgUrl: "allTheTools.subscriptions.screenUrl",
    flag: 'subscriptions',
    docsUrl: "allTheTools.subscriptions.docsUrl"
  },
  {
    title: "allTheTools.console.title",
    description: "allTheTools.console.description",
    icon: ConsoleIcon,
    imgUrl: "allTheTools.console.screenUrl",
    flag: 'console'
  },
];

